enum PensionTransactionType {
  CONTRIBUTION = 'CONTRIBUTION',
  SELL = 'SELL',
  BUY = 'BUY',
  CORRECTION = 'CORRECTION',
  MOVE = 'MOVE',
  COSTS = 'COSTS',
  PAYOUT = 'PAYOUT',
  OTHER = 'OTHER',
}

export default PensionTransactionType;
